module.exports = __webpack_public_path__ + "img/hna_milie.ae021668.jpg";